module.exports = __webpack_public_path__ + "img/10.9395a9e4.png";